/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetPartnerParams,
  ListPartnersParams,
  PaginatedPartners,
  Partner,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List partners
 */
export const listPartners = (
    params?: MaybeRefOrGetter<ListPartnersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedPartners>(
      {url: `/partners`, method: 'GET',
        params, signal
    },
      );
    }




export const getListPartnersQueryKey = (params?: MaybeRefOrGetter<ListPartnersParams>,) => {
    return [
    'partners', ...(params ? [params] : [])
    ] as const;
    }


export const getListPartnersQueryOptions = <TData = Awaited<ReturnType<typeof listPartners>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListPartnersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPartnersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPartners>>> = ({ signal }) => listPartners(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>
}

export type ListPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof listPartners>>>
export type ListPartnersQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List partners
 */

export function useListPartners<TData = Awaited<ReturnType<typeof listPartners>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListPartnersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPartners>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPartnersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Partner details
 */
export const getPartner = (
    id: MaybeRefOrGetter<number>,
    params: MaybeRefOrGetter<GetPartnerParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<Partner>(
      {url: `/partners/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPartnerQueryKey = (id: MaybeRefOrGetter<number>,
    params?: MaybeRefOrGetter<GetPartnerParams>,) => {
    return [
    'partners',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPartnerQueryOptions = <TData = Awaited<ReturnType<typeof getPartner>>, TError = ErrorType<SchemaValidationErrorResponse | void | StandardError>>(id: MaybeRefOrGetter<number>,
    params: MaybeRefOrGetter<GetPartnerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPartnerQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartner>>> = ({ signal }) => getPartner(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>
}

export type GetPartnerQueryResult = NonNullable<Awaited<ReturnType<typeof getPartner>>>
export type GetPartnerQueryError = ErrorType<SchemaValidationErrorResponse | void | StandardError>


/**
 * @summary Partner details
 */

export function useGetPartner<TData = Awaited<ReturnType<typeof getPartner>>, TError = ErrorType<SchemaValidationErrorResponse | void | StandardError>>(
 id: MaybeRefOrGetter<number>,
    params: MaybeRefOrGetter<GetPartnerParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartner>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPartnerQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






